export const SESSION_INITIAL_STATE = {
  token: null,
  isAuthenticated: false,
  firstName: '',
  lastName: '',
  email: '',
  accessToken: '',
  logout: () => {},
  changeMFAMethod: () => {},
};

export const sessionReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'SIGN_IN': {
      return {
        ...state,
        isAuthenticated: false,
        firstName: '',
        accessToken: '',
        lastName: '',
        email: '',
        logout: null,
        changeMFAMethod: null,
      };
    }
    case 'SIGN_IN_SUCCESS':
      return {
        ...state,
        accessToken: action.payLoad.accessToken,
        firstName: action.payLoad.firstName,
        lastName: action.payLoad.lastName,
        email: action.payLoad.email,
        isAuthenticated: true,
        logout: action.payLoad.logout,
        changeMFAMethod: action.payLoad.changeMFAMethod,
      };
    case 'SILENT_REFRESH':
      return {
        ...state,
        accessToken: action.payLoad.accessToken,
        firstName: action.payLoad.firstName,
        lastName: action.payLoad.lastName,
        isAuthenticated: true,
        email: action.payLoad.email,
        logout: action.payLoad.logout,
        changeMFAMethod: action.payLoad.changeMFAMethod,
      };
    case 'SIGN-OUT':
      return {
        isAuthenticated: false,
      };
    default:
      throw new Error();
  }
};
